import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DeprecatedDataFieldGroupValuesComponent } from '@app/modules/employees/components/deprecated-data-field-group-values/deprecated-data-field-group-values.component';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { BalanceSummaryComponent } from '@employees/components/balance-summary/balance-summary.component';
import { DataFieldGroupsComponent } from '@employees/components/data-field-groups/data-field-groups.component';
import { LeaveOfAbsenceDetailsComponent } from './components/leave-of-absence-details/leave-of-absence-details.component';
/* Components */
import { DataFieldsComponent } from '@employees/components/data-fields/data-fields.component';
import { EmployeeHeaderComponent } from '@employees/components/employee-header/employee-header.component';
import { TaskChecklistComponent } from '@employees/components/task-checklist/task-checklist.component';
import { TaskDetailsComponent } from '@employees/components/task-details/task-details.component';
import { EmployeeFormsModule } from '../forms/employees/employee-forms.module';
import { DataFieldGroupValuesComponent } from './components/data-field-group-values/data-field-group-values.component';
import { DeprecatedTaskChecklistComponent } from './components/task-checklist/deprecated/deprecated-task-checklist.component';
import { DeprecatedTaskDetailsComponent } from './components/task-details/deprecated/deprecated-task-details.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        AppCommonModule,
        PlatformModule,
        EmployeeFormsModule,
    ],
    declarations: [
        /* Components */
        DataFieldsComponent,
        DataFieldGroupsComponent,
        DeprecatedDataFieldGroupValuesComponent,
        DataFieldGroupValuesComponent,
        BalanceSummaryComponent,
        EmployeeHeaderComponent,
        TaskChecklistComponent,
        DeprecatedTaskChecklistComponent,
        TaskDetailsComponent,
        DeprecatedTaskDetailsComponent,
        LeaveOfAbsenceDetailsComponent,
    ],
    exports: [
        /* Components */
        DataFieldsComponent,
        DataFieldGroupsComponent,
        DeprecatedDataFieldGroupValuesComponent,
        DataFieldGroupValuesComponent,
        BalanceSummaryComponent,
        EmployeeHeaderComponent,
        TaskChecklistComponent,
        DeprecatedTaskChecklistComponent,
        TaskDetailsComponent,
        DeprecatedTaskDetailsComponent,
    ],
})
export class EmployeesCommonModule {}
